export const validDistricts = [4, 5, 17, 18, 19, 21, 22]
